<ng-container *ngIf="!loading">
  <header class="header profile-header">
    <div class="Flexbox">
      <div class="header-content contnet-filters Flexbox Flexbox__flex-1 fs5">
        <gen-test-header-elements [backUrl] = "'dashboard.pathologist.patients'" [backUrlParams]="{hadEnterInit: false,resource: 'patient'}"
                                  [showPatientWarning]="isShowWarning()"
                                  class="content-item Flexbox Spacebox__lr-small patient-profile profile-header-section"
                                  style="font-size: 1.21rem; flex-wrap: wrap; flex: 1 1 auto"
                                  [patientId]="patientId"></gen-test-header-elements>


        <div class="Flexbox Flexbox__box-direction-column Flexbox__box-align-end general-action-buttons"
             style="margin-left: auto">
          <div style="flex-direction: row;display: flex;">

            <div class="action-buttons-wrapper">
              <gen-button *ngIf="userCanCreateTests()" (click)="goToTest()" [iconClass]="'icon__add new-patient-add-icon'" [text]="'Start New'"></gen-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title">Treatment Plans</div>
  </header>
  <div class="page-content patient-dashboard-worklist" style="height: 100%">
    <gen-worklist
        class="worklist"
        style="height: 100%"
        rowHover="true"
        [resource]="'patient'"
        [searchText]="''"
        [load]="loading">
    </gen-worklist>
  </div>
</ng-container>

<ng-container *ngIf="loading">
  <gen-overlay-loader [showOverlay]="true"></gen-overlay-loader>
</ng-container>
